<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Generate Activation',
                    to: { path: '/code-activation' },
                },
                { text: 'Detail Kode Aktivasi' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Detail Kode Aktifasi</h3>

        <v-card flat>
            <v-card-title>
                Detail Kode Aktivasi <v-spacer></v-spacer>

                <!-- <v-btn
          depressed
          rouded
          small
          class="pa-2"
          height="33px"
          color="#EC675E"
          style="min-width: 0 !important"
        >
          <v-icon color="white" style="font-size: 20px">
            mdi-delete-outline
          </v-icon>
        </v-btn> -->
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div class="mb-5 mt-3">
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <td width="20%">Tanggal Pembuatan</td>
                                    <td>
                                        {{ data.generated_date }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Jumlah User</td>
                                    <td>
                                        {{ data.code_count }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Paket</td>
                                    <td>
                                        {{ data.package_name }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Kelas</td>
                                    <td>
                                        {{ data.grade }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Download</td>
                                    <td>
                                        <v-btn
                                            depressed
                                            rouded
                                            small
                                            class="pa-2"
                                            height="33px"
                                            color="#E8F5FA"
                                            style="min-width: 0 !important"
                                            @click="downloadFile()"
                                        >
                                            <v-icon
                                                color="blew"
                                                style="font-size: 18px"
                                            >
                                                mdi-tray-arrow-down
                                            </v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-card-text>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import axios from "axios";
import moment from "moment";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            token: JSON.parse(localStorage.getItem("token")).value,
            isLoading: false,
            data: [],
        };
    },

    watch: {},

    mounted: function () {
        this.fetchData();
    },

    methods: {
        fetchData() {
            const context = this;
            const id = this.$route.query.id;
            const url = `${process.env.API_BASE_URL}account/code/history/${id}/detail`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.user_groups = [];
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data = response.data;
                    context.data.generated_date =
                        moment(response.data.generated_date).format(
                            "DD/MM/YYYY",
                        ) || "-";
                }
            });
        },
        downloadFile() {
            const context = this;
            const param = `document_url=${context.data.file_url}`;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/download/documentation?${param}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    var url = response.data.download_url;
                    window.open(url, "_blank");
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// CodeActivationDetail.vue?1a8a57e7